module.exports = __webpack_public_path__ + "media/d-2.6dadb70b.mp3";